export default {
  FormName: 'ManufacturerModelAddEditForm',
  FormTitle: 'ManufacturerModel'
};
